import classNames from "classnames";
import PropTypes from "prop-types";
import moment from "moment";
import isFunction from "lodash/isFunction";
import range from "lodash/range";
import { FormItem } from "components";
import { countries } from "i18n-iso-countries/langs/de.json";
import messages from "i18n/messages";
import flowRight from "lodash/flowRight";
import { makeSelectDateById } from "logic/dates";
import {
  disableCustomerDeliveryAddr,
  enableCustomerDeliveryAddr,
  makeSelectCustomer,
  updateCustomerAddrIndexAttr,
  updateCustomerAttr,
  setCustomerFromLS,
} from "logic/customers";
import { makeSelectCurOrg } from "logic/orgs";
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { Alert, Col, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { createStructuredSelector } from "reselect";
import { FormattedHTMLMessage } from "react-intl";

const countryOpts = Object.keys(countries).map((ccode) => ({
  value: ccode,
  label: countries[ccode],
}));

class ContactForm extends Component {
  static async getInitialProps(ctx) {
    const { id } = ctx.query;
    ctx.store.dispatch(fetchOrderById(id));

    return { pageProps: { id } };
  }

  static propTypes = {
    isVoucher: PropTypes.bool,
  };

  static defaultProps = {
    isVoucher: false,
  };

  componentDidMount() {
    this.props.actions.setCustomerFromLS();
  }

  handleChange = (key, value) => {
    if (isFunction(this.props.resetEmailError) && key == "email")
      this.props.resetEmailError();
    this.props.actions.updateCustomerAttr(key, value);
  };

  handleChangeAddrIndex = (index) => (key, value) =>
    this.props.actions.updateCustomerAddrIndexAttr(index, key, value);

  handleChangeAddrIndexCountry = (index) => (val) =>
    this.props.actions.updateCustomerAddrIndexAttr(
      index,
      "country_code",
      val.value
    );

  handleToggleRegisterNew = () =>
    this.props.actions.updateCustomerAttr(
      "register_new",
      !this.props.customer.register_new
    );

  handleToggleAcceptTerms = () =>
    this.props.actions.updateCustomerAttr(
      "accept_terms",
      !this.props.customer.accept_terms
    );

  handleChangeCountry = (val) =>
    this.props.actions.updateCustomerAttr("country_code", val.value);

  handleToggleDeliveryAddress = () =>
    this.props.customer.addresses.length > 0
      ? this.props.actions.disableCustomerDeliveryAddr()
      : this.props.actions.enableCustomerDeliveryAddr();

  handleChangeDeliverySlot = ({ target }) =>
    this.props.actions.updateCustomerAttr(
      "meta.pp_delivery_slot",
      target.checked ? target.value : null
    );

  renderPinkPedalsDeliverySlot = (customer, start) => (
    <FormGroup check className="align-left">
      <Label check>
        <Input
          type="checkbox"
          value={start}
          checked={customer.meta.pp_delivery_slot === start}
          onChange={this.handleChangeDeliverySlot}
        />
        <span className="form-check-sign" />
        {start} Uhr
      </Label>
    </FormGroup>
  );

  renderPinkPedalsDeliverySlots = (customer) => (
    <div className="my-4">
      <hr />
      <FormGroup className="mt-2">
        <Label>
          <FormattedMessage {...messages.deliverySlot} />
          <span className="required-asterisk">*</span>
        </Label>
        <FormText>
          <FormattedMessage
            {...messages.deliverySlotDesc}
            values={{
              b: (chunks) => <b>{chunks}</b>,
              date: moment(this.props.date.starts_at).format("dddd, DD. MMM"),
            }}
          />
        </FormText>
      </FormGroup>
      <Row>
        {range(9).map((hour) => (
          <Col xs={6} lg={3} key={`cust-${Math.random(100)}`}>
            {this.renderPinkPedalsDeliverySlot(
              customer,
              `${hour + 9}:00 - ${hour + 9}:30`
            )}
            {this.renderPinkPedalsDeliverySlot(
              customer,
              `${hour + 9}:30 - ${hour + 10}:00`
            )}
          </Col>
        ))}
      </Row>
    </div>
  );

  renderCustomerDeliveryAddr = (addr, index) => (
    <div key={`addr-${index}`}>
      <hr />
      <h3>
        <FormattedMessage {...messages.deliveryAddr} />
      </h3>
      <FormItem
        name="street"
        onChange={this.handleChangeAddrIndex(index)}
        obj={addr}
        required
      />
      <Row>
        <Col lg={3}>
          <FormItem
            name="postcode"
            onChange={this.handleChangeAddrIndex(index)}
            obj={addr}
            required
          />
        </Col>
        <Col lg={9}>
          <FormItem
            name="city"
            onChange={this.handleChangeAddrIndex(index)}
            obj={addr}
            required
          />
        </Col>
      </Row>
      <FormGroup>
        <Label>
          <FormattedMessage {...messages.country} />
        </Label>
        <Select
          className="primary"
          id="delivery-addr-select-country"
          optionClassName="needsclick"
          name="country_code"
          required
          value={countryOpts.find((o) => o.value === addr.country_code)}
          onChange={this.handleChangeAddrIndexCountry(index)}
          options={countryOpts}
        />
      </FormGroup>
    </div>
  );

  renderPinkPedalsCustomerDeliveryAddr = (addr, index) => (
    <div key={`addr-${index}`}>
      <hr />
      <h3>
        <FormattedMessage {...messages.deliveryAddr} />
      </h3>
      <FormItem
        name="street"
        onChange={this.handleChangeAddrIndex(index)}
        obj={addr}
        required
      />
      <Row>
        <Col lg={3}>
          <FormItem
            name="postcode"
            onChange={this.handleChangeAddrIndex(index)}
            obj={addr}
            required
          />
        </Col>
        <Col lg={9}>
          <FormItem
            name="city"
            obj={addr}
            value={this.props.org.addr.city}
            onChange={this.handleChangeAddrIndex}
            required
            disabled
          />
        </Col>
      </Row>
      <FormItem
        name="ring_info"
        onChange={this.handleChangeAddrIndex(index)}
        obj={addr}
        required
      />
      <FormGroup>
        <Label>
          <FormattedMessage {...messages.country} />
        </Label>
        <Select
          className="primary"
          id="delivery-addr-select-country"
          optionClassName="needsclick"
          name="country_code"
          required
          isDisabled
          value={countryOpts.find(
            (o) => o.value === this.props.org.addr.country_code
          )}
          onChange={this.handleChangeAddrIndexCountry(index)}
          options={countryOpts}
        />
      </FormGroup>
    </div>
  );

  resOnly = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("r") === "1";
  };

  render() {
    const {
      customer,
      collapsed,
      deliveryMethod,
      date,
      isVoucher,
      required = true,
    } = this.props;
    const shippingRequested =
      deliveryMethod &&
      (deliveryMethod === "post" || deliveryMethod === "bicycle");

    return (
      <div className={classNames("contact-form tt-checkout", { collapsed })}>
        <div className="section-header">
          <h2>
            <FormattedMessage {...messages.contactData} />
          </h2>
          <div className="agreed-terms">
            {customer.firstname} {customer.lastname}
          </div>
          <span
            className={`tt-icon tt-icon-${collapsed ? "down" : "up"}-arrow`}
            onClick={this.props.toggleCollapsed}
          />
        </div>
        {/* <div className="continue-btn-wrap">
          <FormGroup check className="align-left">
            <Label check>
              <Input
                type="checkbox"
                checked={customer.register_new || false}
                onChange={this.handleToggleRegisterNew}
              />
              <span className="form-check-sign" />
              <FormattedMessage {...messages.createNewAccount} />
            </Label>
          </FormGroup>
          {customer.register_new
            ? <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={customer.accept_terms || false}
                  onChange={this.handleToggleAcceptTerms}
                />
                <span className="form-check-sign" />
                <FormattedMessage {...messages.acceptCustomerTerms} />
              </Label>
            </FormGroup>
            : <Button color="link">
              <FormattedMessage {...messages.loginExistingUser} />
            </Button>
          }
        </div>
        <hr /> */}
        <div className="collapsed-content">
          <Row>
            <Col xs={12} sm={6}>
              <FormItem
                name="firstname"
                onChange={this.handleChange}
                obj={customer}
                required={required}
                validationError="please enter a value"
              />
            </Col>
            <Col xs={12} sm={6}>
              <FormItem
                name="lastname"
                onChange={this.handleChange}
                obj={customer}
                required={required}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={7}>
              <FormItem
                name="email"
                onChange={this.handleChange}
                obj={customer}
                required
                type="email"
              />
              {this.props.emailError ? (
                <Alert color="warning">
                  <FormattedMessage {...messages.invalidEmail} />
                </Alert>
              ) : null}
            </Col>
            <Col lg={5}>
              <FormItem
                name="phone"
                required={deliveryMethod === "bicycle"}
                onChange={this.handleChange}
                obj={customer}
              />
            </Col>
          </Row>
          <p>
            <FormText>
              <FormattedMessage
                {...messages.explainRequiredFields}
                values={{ sup: (...chunks) => <sup key="ttt">{chunks}</sup> }}
              />
            </FormText>
          </p>
          {(date && date.sale_enabled && !this.resOnly()) || isVoucher ? (
            <>
              <hr />
              <h3>
                <FormattedMessage {...messages.billingAddr} />
              </h3>
              <FormItem
                name="street"
                onChange={this.handleChange}
                obj={customer}
                required={shippingRequested}
              />
              <Row>
                <Col lg={3}>
                  <FormItem
                    name="postcode"
                    onChange={this.handleChange}
                    obj={customer}
                    required={shippingRequested}
                  />
                </Col>
                <Col lg={9}>
                  <FormItem
                    name="city"
                    obj={customer}
                    onChange={this.handleChange}
                    value={
                      deliveryMethod === "bicycle"
                        ? this.props.org.addr.city
                        : customer.addresses.city
                    }
                    disabled={deliveryMethod === "bicycle"}
                    required={shippingRequested}
                  />
                </Col>
              </Row>
              {deliveryMethod === "bicycle" ? (
                <FormItem
                  name="ring_info"
                  onChange={this.handleChange}
                  obj={customer}
                />
              ) : null}
              <FormGroup>
                <Label>
                  <FormattedMessage {...messages.country} />
                </Label>
                <Select
                  className="primary"
                  instanceId="billing-addr-select-country"
                  optionClassName="needsclick"
                  name="country_code"
                  required={shippingRequested}
                  isDisabled={deliveryMethod === "bicycle"}
                  value={
                    deliveryMethod === "bicycle"
                      ? countryOpts.find(
                          (o) => o.value === this.props.org.addr.country_code
                        )
                      : countryOpts.find(
                          (o) => o.value === customer.country_code
                        )
                  }
                  onChange={this.handleChangeCountry}
                  options={countryOpts}
                />
              </FormGroup>
            </>
          ) : null}
          {shippingRequested ? (
            <div>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={
                      customer.addresses && customer.addresses.length < 1
                    }
                    onChange={this.handleToggleDeliveryAddress}
                  />
                  <span className="form-check-sign" />
                  <FormattedMessage {...messages.deliveryAddrEqBillingAddr} />
                </Label>
              </FormGroup>
              {customer.addresses &&
              customer.addresses.length > 0 &&
              (!date || !date.pp_delivery)
                ? customer.addresses.map((addr, index) =>
                    this.renderCustomerDeliveryAddr(addr, index)
                  )
                : null}
              {customer.addresses &&
              customer.addresses.length > 0 &&
              date &&
              date.pp_delivery
                ? customer.addresses.map((addr, index) =>
                    this.renderPinkPedalsCustomerDeliveryAddr(addr, index)
                  )
                : null}
              {date && date.pp_delivery
                ? this.renderPinkPedalsDeliverySlots(customer)
                : null}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  customer: makeSelectCustomer(),
  org: makeSelectCurOrg(),
  date: makeSelectDateById((props) => props.dateId),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateCustomerAttr,
      enableCustomerDeliveryAddr,
      disableCustomerDeliveryAddr,
      setCustomerFromLS,
      updateCustomerAddrIndexAttr,
    },
    dispatch
  ),
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(ContactForm);
